var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AddIcon from '@mui/icons-material/AddCircleRounded';
import EyeIcon from '@mui/icons-material/VisibilityRounded';
export var Option = function (_a) {
    var iconSrc = _a.iconSrc, text = _a.text, onAddClick = _a.onAddClick, onEyeClick = _a.onEyeClick, onClick = _a.onClick, selected = _a.selected, _b = _a.addIconProps, addIconProps = _b === void 0 ? {} : _b, _c = _a.eyeIconProps, eyeIconProps = _c === void 0 ? {} : _c, _d = _a.iconAlt, iconAlt = _d === void 0 ? 'Section Icon' : _d, props = __rest(_a, ["iconSrc", "text", "onAddClick", "onEyeClick", "onClick", "selected", "addIconProps", "eyeIconProps", "iconAlt"]);
    return (<div onClick={onClick} {...props}>
    <img src={iconSrc} alt={iconAlt}/>
    <span>{text}</span>
    {onAddClick && (<AddIcon onClick={function (e) {
                e.stopPropagation();
                onAddClick(e);
            }} {...addIconProps}/>)}
    {onEyeClick && (<EyeIcon onClick={function (e) {
                e.stopPropagation();
                onEyeClick(e);
            }} {...eyeIconProps}/>)}
  </div>);
};
